export { default } from './MadeByMe';
